// @ts-check

// Vendor imports
const React = require('react')

/**
 * @returns {boolean}
 */
function useIsHydrated() {
  const [ isHydrated, setHydrated ] = React.useState(false)
  React.useEffect(
    () => {
      if (typeof window === 'object') {
        setHydrated(true)
      }
    },
    []
  )
  return isHydrated
}

module.exports = {
  useIsHydrated
}
